var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    [
      _c(
        "v-flex",
        [
          _c("router-link", { attrs: { to: { name: "monitorGroupsList" } } }, [
            _vm._v("<<Back to Monitoring Groups List"),
          ]),
          _vm._v(" "),
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _c(
                  "h3",
                  [
                    _vm._v(_vm._s(_vm.accessGroup.name) + "\n            "),
                    _c(
                      "v-tooltip",
                      {
                        attrs: { bottom: "" },
                        scopedSlots: _vm._u([
                          {
                            key: "activator",
                            fn: function ({ on }) {
                              return [
                                _vm.accessGroup.default
                                  ? _c("v-icon", [_vm._v("group")])
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      },
                      [_vm._v(" "), _c("span", [_vm._v("Public Group")])]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-form",
                    {
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                        },
                      },
                      model: {
                        value: _vm.valid,
                        callback: function ($$v) {
                          _vm.valid = $$v
                        },
                        expression: "valid",
                      },
                    },
                    [
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", "pr-4": "" } },
                            [
                              _c(
                                "v-layout",
                                { attrs: { wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { "xs-12": "", "pr-4": "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Name",
                                          rules: [_vm.rules.required],
                                        },
                                        on: { input: _vm.changed },
                                        model: {
                                          value: _vm.accessGroup.name,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.accessGroup,
                                              "name",
                                              $$v
                                            )
                                          },
                                          expression: "accessGroup.name",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", "pr-4": "" } },
                                    [
                                      _c("v-textarea", {
                                        attrs: { label: "Description" },
                                        on: { input: _vm.changed },
                                        model: {
                                          value: _vm.accessGroup.description,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.accessGroup,
                                              "description",
                                              $$v
                                            )
                                          },
                                          expression: "accessGroup.description",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", "pl-4": "" } },
                            [
                              _c(
                                "div",
                                [
                                  _c("v-select", {
                                    attrs: {
                                      label: "Service Account",
                                      items: _vm.getAvailableUsers,
                                      "item-text": "login",
                                      "item-value": "id",
                                    },
                                    on: { input: _vm.changed },
                                    model: {
                                      value: _vm.selectedUserId,
                                      callback: function ($$v) {
                                        _vm.selectedUserId = $$v
                                      },
                                      expression: "selectedUserId",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _c("v-checkbox", {
                                    attrs: {
                                      "input-value": _vm.accessGroup.default,
                                      label: "Public",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.changeDefault($event)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-checkbox", {
                                attrs: { label: "Uniform Credentials" },
                                model: {
                                  value: _vm.accessGroup.uniformSecurity,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.accessGroup,
                                      "uniformSecurity",
                                      $$v
                                    )
                                  },
                                  expression: "accessGroup.uniformSecurity",
                                },
                              }),
                              _vm._v(" "),
                              _vm.accessGroup.uniformSecurity
                                ? _c(
                                    "div",
                                    [
                                      _vm.endpointCount === 0
                                        ? _c("span", [
                                            _vm._v(
                                              "\n              This feature requires at least one fully configured Endpoint in the monitoring group.\n            "
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.hasEpWNoCreds
                                        ? _c("span", [
                                            _vm._v(
                                              "\n              Please ensure credentials are set for Endpoints in the monitoring group.\n            "
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.hasEpWcreds
                                        ? _c("span", [
                                            _vm._v(
                                              "\n              When new Endpoints are added to this monitoring group, they will inherit credentials from existing Endpoints in this group.\n            "
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("p"),
                                      _vm._v(" "),
                                      _vm.endpointCount > 0
                                        ? _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                text: "",
                                                color: "primary",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.pwdChangeDialog = true
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "Bulk Reset Credentials for Member Endpoints"
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            [
                              _c("endpoints-grid", {
                                attrs: {
                                  endpoints: _vm.accessGroup.endpoints,
                                  title: "Member Endpoints",
                                  rowsPerPage: 5,
                                  loading: _vm.loading,
                                  selection: true,
                                  showId: false,
                                  reset: _vm.resetFlag,
                                },
                                on: {
                                  selectionChanged:
                                    _vm.memberEndpointsSelectionChanged,
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mt-4 mr-4 was-orange",
                                  attrs: {
                                    disabled:
                                      !_vm.selectedMemberEndpoints.length,
                                    color: "primary",
                                    outlined: "",
                                    rounded: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.unassignEndpoints()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "Remove selected Endpoints from Monitoring Group"
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mt-4 mr-4 was-orange",
                                  attrs: {
                                    color: "primary",
                                    outlined: "",
                                    rounded: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.showAddEndpointDialog = true
                                    },
                                  },
                                },
                                [_vm._v("Add Endpoints")]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mt-4 mr-4 was-orange",
                                  attrs: {
                                    color: "primary",
                                    outlined: "",
                                    rounded: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.resetEndpoints()
                                    },
                                  },
                                },
                                [_vm._v("Reset Endpoint Memberships")]
                              ),
                              _vm._v(" "),
                              _vm.getControlHubEndpoints.length
                                ? _c(
                                    "v-btn",
                                    {
                                      staticClass: "mt-4 mr-4 was-green",
                                      attrs: {
                                        color: "primary",
                                        outlined: "",
                                        rounded: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.showConfigAdminsDialog()
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "Configure Admin Accounts via ControlHub"
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { disabled: !_vm.valid, color: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.saveAccessGroup()
                        },
                      },
                    },
                    [_vm._v("Save")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "700px" },
              model: {
                value: _vm.showAddEndpointDialog,
                callback: function ($$v) {
                  _vm.showAddEndpointDialog = $$v
                },
                expression: "showAddEndpointDialog",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [
                    _c("span", { staticClass: "headline" }, [
                      _vm._v("Add Endpoints to Monitoring Group"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c("endpoints-grid", {
                        attrs: {
                          showAllEndpointsCheckbox: true,
                          endpoints: _vm.getAvailableEndpoints,
                          title: "Available Endpoints",
                          rowsPerPage: 5,
                          loading: _vm.loading,
                          selection: true,
                          showId: false,
                          reset: _vm.resetFlag,
                        },
                        on: {
                          selectionChanged:
                            _vm.availableEndpointsSelectionChanged,
                          unassignedEndpointsChanged:
                            _vm.unassignedEndpointsChanged,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "mr-4",
                          attrs: {
                            color: "primary",
                            outlined: "",
                            rounded: "",
                          },
                          on: {
                            click: function ($event) {
                              _vm.showAddEndpointDialog = false
                            },
                          },
                        },
                        [_vm._v("Close")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            rounded: "",
                            disabled: !_vm.selectedAllEndpoints.length,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.assignEndpoints()
                            },
                          },
                        },
                        [_vm._v("Add Selected Endpoints")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "700px" },
              model: {
                value: _vm.configAdminsDialog,
                callback: function ($$v) {
                  _vm.configAdminsDialog = $$v
                },
                expression: "configAdminsDialog",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [
                    _c("span", { staticClass: "headline" }, [
                      _vm._v(
                        "Configure Admin Accounts for " +
                          _vm._s(_vm.getControlHubEndpoints.length) +
                          " ControlHub Endpoints"
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.getNonControlHubEndpoints.length
                      ? _c("span", { staticClass: "caption" }, [
                          _vm._v(
                            "(" +
                              _vm._s(_vm.getNonControlHubEndpoints.length) +
                              " Endpoints are non-ControlHub and will not be affected)"
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-form",
                        {
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                            },
                          },
                          model: {
                            value: _vm.validXapi,
                            callback: function ($$v) {
                              _vm.validXapi = $$v
                            },
                            expression: "validXapi",
                          },
                        },
                        [
                          _c(
                            "v-layout",
                            { attrs: { wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { "xs-12": "", "pr-4": "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Username",
                                      disabled: "",
                                      rules: [_vm.rules.required],
                                    },
                                    model: {
                                      value: _vm.xapiadminusername,
                                      callback: function ($$v) {
                                        _vm.xapiadminusername = $$v
                                      },
                                      expression: "xapiadminusername",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", "pr-4": "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      type: "password",
                                      label: "Password",
                                      rules: [
                                        _vm.rules.required,
                                        _vm.rules.pwdFormat,
                                      ],
                                    },
                                    model: {
                                      value: _vm.xapiadminuserpassword,
                                      callback: function ($$v) {
                                        _vm.xapiadminuserpassword = $$v
                                      },
                                      expression: "xapiadminuserpassword",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", "pr-4": "" } },
                                [
                                  _vm._v(
                                    "\n              Please do not share this password with other vendors or users.\n          "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "mr-4",
                          attrs: {
                            color: "primary",
                            outlined: "",
                            rounded: "",
                          },
                          on: { click: _vm.hideConfigAdminsDialog },
                        },
                        [_vm._v("Close")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            outlined: "",
                            rounded: "",
                            disabled: !_vm.validXapi,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.configXapiAdmins()
                            },
                          },
                        },
                        [_vm._v("Apply")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "600px" },
              model: {
                value: _vm.pwdChangeDialog,
                callback: function ($$v) {
                  _vm.pwdChangeDialog = $$v
                },
                expression: "pwdChangeDialog",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [
                    _c("span", { staticClass: "headline" }, [
                      _vm._v(
                        "Set Password for " +
                          _vm._s(_vm.endpointCount) +
                          " Endpoints in Monitoring Group"
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-form",
                        {
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                            },
                          },
                          model: {
                            value: _vm.validPwd,
                            callback: function ($$v) {
                              _vm.validPwd = $$v
                            },
                            expression: "validPwd",
                          },
                        },
                        [
                          _c("v-text-field", {
                            attrs: {
                              rules: [_vm.rules.required],
                              label: "Login",
                            },
                            model: {
                              value: _vm.newLogin,
                              callback: function ($$v) {
                                _vm.newLogin = $$v
                              },
                              expression: "newLogin",
                            },
                          }),
                          _vm._v(" "),
                          _c("v-text-field", {
                            attrs: {
                              rules: [_vm.rules.required],
                              type: "password",
                              label: "Password",
                            },
                            model: {
                              value: _vm.newPassword,
                              callback: function ($$v) {
                                _vm.newPassword = $$v
                              },
                              expression: "newPassword",
                            },
                          }),
                          _vm._v(" "),
                          _c("v-text-field", {
                            attrs: {
                              rules: [_vm.rules.match],
                              type: "password",
                              label: "Confirm Password",
                            },
                            model: {
                              value: _vm.confirmPassword,
                              callback: function ($$v) {
                                _vm.confirmPassword = $$v
                              },
                              expression: "confirmPassword",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "mr-4",
                          attrs: {
                            color: "primary",
                            outlined: "",
                            rounded: "",
                          },
                          nativeOn: {
                            click: function ($event) {
                              _vm.pwdChangeDialog = false
                            },
                          },
                        },
                        [_vm._v("Cancel")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            rounded: "",
                            disabled: !_vm.validPwd,
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.saveBulkPassword.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v("Save")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }